<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <img style="display: none;" id='reportLogo' crossorigin="Anonymous" :src="imagepath" alt='Report Logo'>
            <div class="row no-gutters">
                <div class="col-md-12">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="From"><br>
                                            <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                            <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                                <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Sort By" >
                                            <select class="form-control" size="large" v-model="inputSortBy">>
                                                <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                    <div class="col-md-2 mt-3 pt-3">
                                        <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                            {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                        </button>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Status" >
                                            <select class="form-control" size="large" v-model="inputStatus">
                                                <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row" v-if="$attrs.friendlyCode != 'RR' && $attrs.friendlyCode != 'RS' && $attrs.friendlyCode != 'ADI' && $attrs.friendlyCode != 'STI'">
                                    <div class="col-md-7">
                                        <base-input label="Order Status" >
                                            <a-select mode="multiple" v-model="inputOrderStatus" showSearch placeholder="All Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in orderStatusOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
        
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Purpose" >
                                            <a-select
                                                labelInValue
                                                :value="purpose"
                                                placeholder="Select purpose"
                                                style="width: 100%"
                                                :filterOption="false"
                                                @dropdownVisibleChange="fetchPurposes"
                                                @change="selectPurpose"
                                                :notFoundContent="fetching ? undefined : null">
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in purposes" :key="'purposes'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Order Source" >
                                            <a-select mode="multiple" v-model="inputOrderSource" showSearch placeholder="All Source" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in orderSourceOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div class="col-md-3">
                    <base-dropdown class="nav-link pr-0 float-right" style="margin: 10px 10px" position="right">
                        <div class="media align-items-center" slot="title">
                        <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                        </div>
                        <template>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                            <i class="fa fa-list-ul"></i>
                            <span>Customize List</span>
                        </div>
                        </template>
                    </base-dropdown>
                </div>
            </div>
    
            <div class="row">
                <div class="col-md-12">
                    <br>
                    <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                    <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFlatFile">Generate Report</button> &nbsp; &nbsp;
                    <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                        <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                    </vue-json-to-csv>
                    <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                        <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                    </download-excel>
                </div>
            </div>
    
            <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
                <div v-if="profileAction == 'customize_list'">
                    <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="Header" key="1">
                            <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
                                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                    <div class="row">
                                        <div class="col-md-9">
                                            AVAILABLE FIELDS
                                        </div>
                                        <div class="col-md-3">
                                            <a-checkbox @change="onCheckAllField" :checked="checkedHeaderFields.length == availableFields.length" class="float-right" />
                                        </div>
                                    </div>
                                </li>
    
                                <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" v-bind:key="field">
                                    <div class="row">
                                        <div class="col-md-9">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{_.startCase(field)}}
                                        </div>
                                        <div class="col-md-3">
                                            <a-checkbox @change="onCheckField(field)" :checked="checkedHeaderFields.includes(field)" :disabled="defaultCheckedHeaderFields.includes(field)" class="float-right" />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </a-tab-pane>
                        <a-tab-pane tab="Lines" key="2">
                            <ul v-if="availableDetailFields.length > 0" class="list-group list-group-flush" style="width: 100%">
                                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                    <div class="row">
                                        <div class="col-md-9">
                                            AVAILABLE FIELDS
                                        </div>
                                        <div class="col-md-3">
                                            <a-checkbox @change="onCheckAllDetailField" :checked="checkedDetailFields.length == availableDetailFields.length" class="float-right" />
                                        </div>
                                    </div>
                                </li>
    
                                <li class="list-group-item" style="font-size: 14px" v-for="field in availableDetailFields" v-bind:key="field">
                                    <div class="row">
                                        <div class="col-md-9">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{_.startCase(field)}}
                                        </div>
                                        <div class="col-md-3">
                                            <a-checkbox @change="onCheckDetailField(field)" :checked="checkedDetailFields.includes(field)" :disabled="defaultCheckedDetailFields.includes(field)" class="float-right" />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </a-tab-pane>
                    </a-tabs>
                    
                </div>
            </a-drawer>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import { dissectReportFilters } from '../../components/reportUtils';
        import { getReportDescription } from '../../utilities';
    
        import {
            mapState
        } from 'vuex'
    
        export default {
            data() {
                return {
                    imagepath: secureStorage.getItem("account_logo"),
                    spinning: false,
                    inputDate: [moment().startOf('day'), moment().endOf('day')],
                    currDate: moment().format("L_LT").split(":").join(";"),
                    inputStatus: 'P',
                    statusOptions: [
                        {key: 'P', value: 'Posted'},
                        {key: 'S', value: 'Saved'},
                        {key: 'V', value: 'Voided'},
                        {key: '', value: 'All'}

                    ],
                    inputSortBy: 'id',
                    sortOptions: [
                        {key: 'id', value: 'Document ID'}
                    ],
                    inputOrderStatus: [],
                    orderStatusOptions: [
                        {key: "U", value: "Unfulfilled"},
                        {key: "G", value: "Goods Issued"},
                        {key: "F", value: "Fulfilled"},
                        {key: "O", value: "Open Delivery"},
                        {key: "S", value: "Paid"},
                        {key: "P", value: "Partial"},
                        {key: "D", value: "Done"}
                    ],
                    transOptions: [
                        {key: "RECADJ", value: "Adjustment In", document_name: "Adjustment In"},
                        {key: "RELADJ", value: "Adjustment Out", document_name: "Adjustment Out"}
                    ],
                    inputSite: [],
                    site_type: "ho",
                    showSortInfo: 'asc',
                    drawerVisible: false,
                    profileAction: '',
                    availableFields: [],
                    availableDetailFields: [],
                    
                    customDetailFields: ["stock_no"],
                    customHeaderFields: ["party_name", "posted_at", "origin_document_date"],
    
                    defaultCheckedDetailFields: ["product_id", "stock_no", "barcode", "product_name", "quantity"],
                    defaultCheckedHeaderFields: ["id", "party_name", "document_date", "posted_at", "origin_document_id", "origin_document_date", "status"],
    
                    checkedDetailFields: ["barcode", "product_name", "brand_name", "company_name", "quantity", "subtotal"],
                    checkedHeaderFields: ["order_source","document_no", "site_name", "document_date", "posted_at", "status", "cas_no","purpose","reference","remarks"],
                    
                    siteOptions: [],
                    birSalesReports: [],
                    JsonData: [],
                    userProductGroupAccess: [],
                    purpose: [],
                    purposes: [],
                    fetching: false,
                    currentDocumentTypeId: 0,
                    reportDescription: '',
                    inputOrderSource: [],
                    orderSourceOptions: [
                        { key: '', value: 'All'},
                        { key: 'pcv', value: 'PCV'},
                        { key: 'tov', value: 'TOV'},
                        { key: 'regular', value: 'Regular'},
                        { key: 'E-Commerce', value: 'Ecomm'},
                        { key: 'barter_tool', value: 'Barter Tool'},
                        { key: 'barter_tool_3p', value: 'Barter Tool 3P'},
                        { key: 'liquidation', value: 'Liquidation'}
                    ]
                }
            },          
            mounted: async function () {
                var component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputSite = [siteId]
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
    
                let userGroupPermission = await HTTPRequest.getRequest(this.endPoint + "/user_memberships/get_user_group_permissions?system_module_name='products'&user_id=" + userId, null )
                if(userGroupPermission != null){
                    this.userProductGroupAccess = userGroupPermission.access_right
                }
    
                const operationsReport = localStorage.getItem(this.currentProfile + "operationsReport")
                // console.log(operationsReport)
                if(operationsReport != undefined && operationsReport != null && operationsReport != "[]"){
                    this.checkedHeaderFields = JSON.parse(operationsReport)
                }else{
                    localStorage.removeItem(this.currentProfile+ "operationsReport")
                }
                const operationsReportDetail = localStorage.getItem(this.currentProfile + "operationsReportDetail")
                // console.log(operationsReport)
                if(operationsReportDetail != undefined && operationsReportDetail != null && operationsReportDetail != "[]"){
                    this.checkedDetailFields = JSON.parse(operationsReportDetail)
                }else{
                    localStorage.removeItem(this.currentProfile + "operationsReportDetail")
                }
    
                var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
                let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).document_name
                
                this.currentDocumentTypeId = document_types.find(x => x.value === trans_val).key
                this.reportDescription = await getReportDescription(this.currentProfile)
    
                console.log(this.checkedHeaderFields, this.checkedDetailFields)
            },
            computed: {
                ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
            },
            components:{
                VueJsonToCsv
            },
            methods: {
                moment,
                async fetchPurposes() {
                    this.fetching = true
                    this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+this.currentDocumentTypeId, null)
                    this.purposes.push({id: -1, name: "All Purpose"})
                    console.log(this.purposes,this.currentDocumentTypeId)
                    this.purposes.sort((a, b) => {
                        return a.id - b.id;
                    });
                    this.fetching = false
                },
                selectPurpose (purpose) {
                    var arr = {
                        key:purpose.key.replace('purposes',''),
                        label:purpose.label
                    }
                    purpose = arr
                    Object.assign(this, {
                        purpose,
                        purposes: [],
                        fetching: false,
                    })
                },
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                openNotificationWithIcon(type, msg) {
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg 
                    });
                },
                onClose() {
                    this.drawerVisible = false
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                async showActionDrawer(action) {
                    if (action == "customize_list") {
                        let response = await HTTPRequest.getRequest(this.endPoint + "documents/get_viewable_fields", null)
                        this.availableFields = response["fields"]
                        this.availableFields = this.customHeaderFields.concat(this.availableFields)
    
                        let detailresponse = await HTTPRequest.getRequest(this.endPoint + "document_lines/get_viewable_fields", null)
                        this.availableDetailFields = detailresponse["fields"]
                                            
                        if(!this.userProductGroupAccess.includes("Z")){
                            this.availableDetailFields = this.availableDetailFields.filter(e => e !== "cost")
                        }
                        if(!this.userProductGroupAccess.includes("Y")){
                            this.availableDetailFields = this.availableDetailFields.filter(e => e !== "price")
                        }
    
                        this.availableDetailFields = this.customDetailFields.concat(this.availableDetailFields)
    
                    }
    
                    this.profileAction = action
                    this.drawerVisible = true
                },
                rejectReference(data){
                    let strData = JSON.stringify(data)
                    let parseData = JSON.parse(strData)
                    return parseData;
                },
                onCheckAllDetailField() {     
                    if(this.checkedDetailFields.length == this.availableDetailFields.length){
                        this.checkedDetailFields = this.rejectReference(this.defaultCheckedDetailFields)
                    } else {
                        this.checkedDetailFields = this.rejectReference(this.defaultCheckedDetailFields)
    
                        for(let v=0; v < this.availableDetailFields.length; v++){
                            let fieldName = this.availableDetailFields[v]
                            if(this.checkedDetailFields.includes(fieldName)){
                                //do nothing
                            } else {
                                this.checkedDetailFields.push(fieldName)
                            }
                        }
                    }
                    let storeName = this.currentProfile + "operationsReportDetail" 
                    localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
                },
                onCheckDetailField(fieldName) {
                    if(this.checkedDetailFields.includes(fieldName)){
                        var indexValue = this.checkedDetailFields.indexOf(fieldName)
                        if (indexValue > -1) 
                            var indexValue2 = this.checkedDetailFields.indexOf(fieldName)
                        if (indexValue2 > -1) 
                            this.checkedDetailFields.splice(indexValue2, 1)
                    }else{
                        this.checkedDetailFields.push(fieldName)
                    }
                    let storeName = this.currentProfile + "operationsReportDetail" 
                    localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
                },
                onCheckAllField() {     
                    if(this.checkedHeaderFields.length == this.availableFields.length){
                        this.checkedHeaderFields = this.rejectReference(this.defaultCheckedHeaderFields)
                    } else {
                        this.checkedHeaderFields = this.rejectReference(this.defaultCheckedHeaderFields)
                        for(let v=0; v < this.availableFields.length; v++){
                            let fieldName = this.availableFields[v]
                            if(this.checkedHeaderFields.includes(fieldName)){
                                //do nothing
                            } else {
                                this.checkedHeaderFields.push(fieldName)
                            }
                        }
                    }
                    let storeName = this.currentProfile + "operationsReport" 
                    localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
                },
                onCheckField(fieldName) {
                    if(this.checkedHeaderFields.includes(fieldName)){
                        var indexValue = this.checkedHeaderFields.indexOf(fieldName)
                        if (indexValue > -1) 
                            var indexValue2 = this.checkedHeaderFields.indexOf(fieldName)
                        if (indexValue2 > -1) 
                            this.checkedHeaderFields.splice(indexValue2, 1)
                    }else{
                        this.checkedHeaderFields.push(fieldName)
                    }
                    let storeName = this.currentProfile + "operationsReport" 
                    localStorage.setItem(storeName, JSON.stringify(this.checkedHeaderFields))
                },
                generateReport: async function () {
                    this.spinning= true;
                    
                    let from_date = null 
                    let to_date = null 
                    
                    try {
                        from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                        to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                    } catch (error) {
                        this.openNotificationWithIcon('error', 'Date range is empty.');
                        this.spinning= false;
                        return
                    }

                    let grandTotalQuantity = 0;
                    let grandTotalSRP = 0;

    
                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from":  from_date,
                        "date_to":  to_date,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "type": this.$attrs.friendlyCode,
                        "status": this.inputStatus,
                        "order_status": this.inputOrderStatus,
                        "purpose": ((this.purpose.key == undefined) ? '-1' :  this.purpose.key),
                        "order_source": this.inputOrderSource
                    }
    
                    // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                    parameters.current_profile = this.currentProfile
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report_ado?', parameters, null);
                    if(this.inputDate.length == 0){
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                        return
                    }
    
                    let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks"]
                    // let reportLogo = document.getElementById('reportLogo');
                    var siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
    
                        let header_prefix = this.$attrs.friendlyCode
                        let origin_prefix = 'Origin Doc'
    
                        let field_count = this.checkedHeaderFields.length
                        let header_count = this.checkedHeaderFields.length
                        let line_count = this.checkedDetailFields.length
                        if(field_count < line_count){
                            field_count = line_count
                        }
    
                        if (this.$attrs.friendlyCode == 'RELADJ'){
                            header_prefix = 'ADO'
                        }
                        let footer_x = 340
                        let footer_y = 210
    
                        let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                        let header_remaining_width = 0
                        let line_remaining_width = 0
                        let header_plus = 30 //party_name = 30
                        let line_plus = 60 //product_name = 30 + indention = 30
    
                        if(field_count <= 11){
                            header_remaining_width = ((11 - header_count) * 30) - header_plus
                            line_remaining_width = ((11 - line_count) * 30) - line_plus
                        } else if(field_count <= 13) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3'});
                            header_remaining_width = ((13 - header_count) * 30) - header_plus
                            line_remaining_width = ((13 - line_count) * 30) - line_plus
    
                            footer_x = 410
                            footer_y = 290
                        } else if(field_count <= 16) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3'});
                            header_remaining_width = ((16 - header_count) * 30) - header_plus
                            line_remaining_width = ((16 - line_count) * 30) - line_plus
    
                            footer_x = 490
                            footer_y = 350
                        } else if(field_count <= 19) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                            header_remaining_width = ((19 - header_count) * 30) - header_plus
                            line_remaining_width = ((19 - line_count) * 30) - line_plus
    
                            footer_x = 580
                            footer_y = 415
                        } else if(field_count <= 23) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b2'});
                            header_remaining_width = ((23 - header_count) * 30) - header_plus
                            line_remaining_width = ((23 - line_count) * 30) - line_plus
    
                            footer_x = 680
                            footer_y = 490
                        } else if(field_count <= 27) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a1'});
                            header_remaining_width = ((27 - header_count) * 30) - header_plus
                            line_remaining_width = ((27 - line_count) * 30) - line_plus
    
                            footer_x = 820
                            footer_y = 590
                        } else if(field_count <= 32) {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b1'});
                            header_remaining_width = ((32 - header_count) * 30) - header_plus
                            line_remaining_width = ((32 - line_count) * 30) - line_plus
    
                            footer_x = 950
                            footer_y = 700
                        } else {
                            doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a0'});
                            header_remaining_width = ((39 - header_count) * 30) - header_plus
                            line_remaining_width = ((39 - line_count) * 30) - line_plus
    
                            footer_x = 1150
                            footer_y = 830
                        }
    
                        let header_fair_plus = header_remaining_width / header_count
                        let line_fair_plus = line_remaining_width / line_count
                        let headerColStyles = {}
                        let lineColStyles = {}
    
                        let dynamic_header = []
                        for(let v=0; v < this.checkedHeaderFields.length; v++){
                            if(this.checkedHeaderFields[v] == 'order_source'){
                                dynamic_header.push({content: 'Order Source', styles: {halign: 'center'}})
                            } else if(this.checkedHeaderFields[v] == 'document_no'){
                                dynamic_header.push({content: `${header_prefix} #`, styles: {halign: 'center'}})
                            } else if(this.checkedHeaderFields[v] == 'site_name'){
                                dynamic_header.push({content: 'Target Branch', styles: {halign: 'center'}})
                            } else if(this.checkedHeaderFields[v] == 'document_date'){
                                dynamic_header.push({content: `${header_prefix} Date`, styles: {halign: 'center'}})
                            } else if(this.checkedHeaderFields[v] == 'posted_at'){
                                dynamic_header.push({content: `${header_prefix} Post Date`, styles: {halign: 'center'}})
                            } else if(this.checkedHeaderFields[v] == 'cas_no'){
                                dynamic_header.push({content: 'Cas Series #', styles: {halign: 'center'}})
                            } else {
                                let s = this.checkedHeaderFields[v]
                                let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                                dynamic_header.push({content: _.startCase(format_header), styles: {halign: 'center'}})
                            } 
    
                            if(this.checkedHeaderFields[v] == 'site_name'){
                                headerColStyles[v] = {cellWidth: 60 + header_fair_plus}
                            } else {
                                headerColStyles[v] = {cellWidth: 30 + header_fair_plus}    
                            }
                        }
    
                        let dynamic_line = []
                        for(let v=0; v < this.checkedDetailFields.length; v++){
                            if(this.checkedDetailFields[v] == 'subtotal'){
                                dynamic_line.push({content: 'Total SRP', styles: {halign: 'center'}})
                            } else if(this.checkedDetailFields[v] == 'product_name'){
                                dynamic_line.push({content: 'Description', styles: {halign: 'center'}})
                            } else {
                                let s = this.checkedDetailFields[v]
                                let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                                dynamic_line.push({content: _.startCase(format_detail), styles: {halign: 'center'}})
                            } 
    
                            if(this.checkedDetailFields[v] == 'product_name'){
                                lineColStyles[v] = {cellWidth: 60 + line_fair_plus}
                            } else {
                                lineColStyles[v] = {cellWidth: 30 + line_fair_plus}    
                            }
                        }
    
                        for(var x=0; x < siteSpecific.length; x++){
                            //doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
    
                            doc.setFontSize(14);
                            doc.setFontType("bold");
    
                            let design_y = 20
    
                            doc.text(15,design_y,`${trans_val} Journal`)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
    
                            design_y = design_y + 5;
                            doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
    
                            if(x > 0){
                                //add new page
                                doc.addPage();
                            }
    
                            design_y = design_y + 5;
                            doc.text(15,design_y,`Site: ${siteSpecific[x].report_details[0].site_name}`)
                            // doc.text(15,design_y + 5, `Purpose: ${this.purpose.label}`)
                            let filterText = dissectReportFilters(parameters, this.displayOptions={}, this.formatOptions={})
                            const { basic } = filterText
                            doc.text(15, 35, `Filter/s: ${basic}`)
                            
                            // design_y = design_y + 5;
                            this.birSalesReports = siteSpecific[x].report_details
    
                            let grouper = ''
                            
    
                            if(this.birSalesReports.length > 0){
                                let headerData = []
                                let reportData = []
                                let subtotal = {}
                                
    
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
    
                                    let header_detail = []
                                    let line_detail = []
    
                                    if(grouper == ''){
                                        for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }
    
                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: moment(reportLine[field_value]).format('MM/DD/YYYY'), styles: {halign: 'center'}})
                                                }
                                            } else if (field_value == 'origin_document_id'){
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: reportLine[field_value], styles: {halign: 'left'}})
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push({content: 'Active', styles: {halign: 'center'}})
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push({content: status_val, styles: {halign: 'center'}})
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push({content: reportLine[field_value], styles: {halign: 'left'}})
                                                }
                                            } 
                                        }
    
                                        headerData.push(header_detail)
    
                                        design_y = design_y + 10;
    
                                        doc.autoTable({
                                            startY: design_y, 
                                            head: [dynamic_header],
                                            body: headerData, 
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: headerColStyles
                                        });
                                    } else {
                                        
                                        if(grouper != reportLine.document_id){
                                            //if new document display prev dostartcument details 
                                            reportData.push(Object.assign({}, ["rowLine"]))
    
                                            let sub_detail = []
                                            for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                                let field_value = this.checkedDetailFields[vd]
                                                if(field_value == 'product_name'){
                                                    sub_detail.push("Sub Total")
                                                } else {
                                                    if(subtotal[field_value] == undefined){
                                                        sub_detail.push('')
                                                    } else {
                                                        grandTotalQuantity += parseFloat(subtotal['quantity'])
                                                        grandTotalSRP += parseFloat(subtotal['subtotal'])
                                                        sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                    }
                                                }   
                                            }
    
                                            reportData.push(Object.assign({}, sub_detail))
    
                                            subtotal = {}
    
                                            doc.autoTable({
                                                head: [dynamic_line],
                                                body: reportData, 
                                                margin: {left: 30},
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'right'
                                                },
                                                columnStyles: lineColStyles,
                                                didParseCell: function(data) {
                                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                        data.cell.styles.fillColor = [0, 0, 0]
                                                        data.cell.styles.fontSize = 1
                                                        data.cell.styles.cellPadding = 0
                                                    } else if (data.row.section == 'body' && data.row.raw[3] == 'Sub Total'){
                                                        data.cell.styles.fontStyle = 'bold'
                                                    }
                                                }
                                            });
    
                                            reportData = []
                                            headerData = []
    
                                            for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                                let field_value = this.checkedHeaderFields[vd]
                                                
                                                if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                    field_value = `document_${field_value}`
                                                }
    
                                                if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                    if(reportLine[field_value] == null){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push({content: moment(reportLine[field_value]).format('MM/DD/YYYY'), styles: {halign: 'center'}})
                                                    }
                                                } else if (field_value == 'origin_document_id'){
                                                    if(reportLine[field_value] == -1){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push({content: reportLine[field_value], styles: {halign: 'left'}})
                                                    }
                                                } else if (field_value == 'document_status'){
                                                    if(reportLine[field_value] == 'A'){
                                                        header_detail.push({content: 'Active', styles: {halign: 'center'}})
                                                    } else {
                                                        let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                        header_detail.push({content: status_val, styles: {halign: 'center'}})
                                                    }
                                                } else {
                                                    if(reportLine[field_value] == null){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push({content: reportLine[field_value], styles: {halign: 'left'}})
                                                    }
                                                } 
                                            }
    
                                            headerData.push(header_detail)
    
                                            doc.autoTable({
                                                head: [dynamic_header],
                                                body: headerData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'right'
                                                },
                                                columnStyles: headerColStyles
                                            });
                                        }
                                    }
                                    
                                    grouper = reportLine.document_id
    
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
    
                                        if(reportLine[field_value] == null){
                                            line_detail.push('')
                                        } else {
                                            // console.log(field_value, reportLine[field_value], typeof(reportLine[field_value]))
                                            let align = 'left'
                                            let convert_me = false
                                            if(no_subtotal.includes(field_value)){
                                                //dont total
                                            } else {
                                                if (typeof(reportLine[field_value]) == "string"){
                                                    // console.log(parseFloat(reportLine[field_value]))
                                                    // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                    if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                        // console.log(subtotal[field_value])
                                                        if(subtotal[field_value] == undefined){
                                                            subtotal[field_value] = Number(reportLine[field_value])
                                                        } else {
                                                            subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                        }
    
                                                        align = 'right'
                                                        convert_me = true
                                                    }
                                                    // console.log(subtotal)
                                                }
                                            }
    
                                            if(convert_me == true){
                                                line_detail.push({content: this.convertToCurrency(Number(reportLine[field_value])), styles: {halign: align}})
                                            } else {
                                                line_detail.push({content: reportLine[field_value], styles: {halign: align}})
                                            }
                                        }
                                    }
    
                                    reportData.push(line_detail)
    
                                    if(i == this.birSalesReports.length-1){
                                        reportData.push(Object.assign({}, ["rowLine"]))
    
                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                sub_detail.push("Sub Total")
                                            } else {
                                                if(subtotal[field_value] == undefined){
                                                    sub_detail.push('')
                                                } else {
                                                    grandTotalQuantity += parseFloat(subtotal['quantity'])
                                                    grandTotalSRP += parseFloat(subtotal['subtotal'])
                                                    sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                }
                                            }   
                                        }
    
                                        reportData.push(Object.assign({}, sub_detail))
    
                                        subtotal = {}

                                        doc.autoTable({
                                            head: [dynamic_line],
                                            body: reportData, 
                                            margin: {left: 30},
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: lineColStyles,
                                            didParseCell: function(data) {
                                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                    data.cell.styles.fillColor = [0, 0, 0]
                                                    data.cell.styles.fontSize = 1
                                                    data.cell.styles.cellPadding = 0
                                                } else if (data.row.section == 'body' && data.row.raw[3] == 'Sub Total'){
                                                    data.cell.styles.fontStyle = 'bold'
                                                }
                                            }
                                        });
                                    }
                                }
                            }
    
                            // GRAND TOTAL SHOULD BE HERE
                           
                            doc.autoTable({
                                // head: [['']],
                                body: [
                                  ['GRAND TOTAL:', `${this.convertToCurrency(grandTotalQuantity)}`,`${this.convertToCurrency(grandTotalSRP)}`],
                                ],
                                margin: {left: 135},
                                theme: 'plain',
                                tableWidth: 'wrap',
                                styles: {
                                    cellPadding: 1.0, fontSize: 12, fontStyle: "bold",
                                    halign: 'right', lineWidth: 0.15
                                },
                                columnStyles: {
                                    0: { cellWidth: 65 },
                                    1: { cellWidth: 65 },
                                    2: { cellWidth: 65 },
                                },
                            })
                        }
    
                        // console.log("~~~~");
                        // console.log(grandTotal);
    
                        // doc.text(footer_x - 10,footer_y - 10,`${grandTotal}`)
                        // doc.text(footer_x - 10,footer_y - 10, [grandTotal], "right")
    
    
                        let pageCount = doc.internal.getNumberOfPages();
                        for(let i = 0; i < pageCount; i++) { 
                            doc.setPage(i);
                            doc.text(footer_x,footer_y,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                        }
    
                        //doc.save(`${this.$attrs.friendlyCode}_Journal_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                        window.open(URL.createObjectURL(doc.output("blob")))
                    } else {
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    }
                    this.spinning= false;
                },
                generateFile: async function() {
                    this.spinning= true;
                    let from_date = null 
                    let to_date = null 
                    
                    try {
                        from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                        to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                    } catch (error) {
                        this.openNotificationWithIcon('error', 'Date range is empty.');
                        this.spinning= false;
                        return
                    }

                    let grandTotal = 0;
                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from":  from_date,
                        "date_to":  to_date,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "type": this.$attrs.friendlyCode,
                        "status": this.inputStatus,
                        "order_status": this.inputOrderStatus,
                        "purpose": ((this.purpose.key == undefined) ? '-1' :  this.purpose.key),
                    }
    
                    // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                    parameters.current_profile = this.currentProfile
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?',parameters, null);
    
                    if(this.inputDate.length == 0){
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                        return
                    }
    
                    let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks"]
    
                    var siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
    
                        let header_prefix = this.$attrs.friendlyCode
                        let origin_prefix = 'Origin Doc'
    
                        if(header_prefix == 'RR'){
                            origin_prefix = 'PO'
                        }
                        let field_count = this.checkedHeaderFields.length
                        let header_count = this.checkedHeaderFields.length
                        let line_count = this.checkedDetailFields.length
                        if(field_count < line_count){
                            field_count = line_count
                        }
                        let site_specific = []
                        let dynamic_header = []
                        for(let v=0; v < this.checkedHeaderFields.length; v++){
                            if(this.checkedHeaderFields[v] == 'id'){
                                dynamic_header.push(`${header_prefix} #`)
                            } else if(this.checkedHeaderFields[v] == 'party_name'){
                                dynamic_header.push('Party')
                            } else if(this.checkedHeaderFields[v] == 'document_date'){
                                dynamic_header.push(`${header_prefix} Date`)
                            } else if(this.checkedHeaderFields[v] == 'posted_at'){
                                dynamic_header.push(`${header_prefix} Post Date`)
                            } else if(this.checkedHeaderFields[v] == 'origin_document_id'){
                                dynamic_header.push(`${origin_prefix} #`)
                            } else if(this.checkedHeaderFields[v] == 'origin_document_date'){
                                dynamic_header.push(`${origin_prefix} Date`)
                            } else {
                                let s = this.checkedHeaderFields[v]
                                let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                                dynamic_header.push(format_header)
                            } 
                        }
    
                        let dynamic_line = []
                        for(let v=0; v < this.checkedDetailFields.length; v++){
                            if(this.checkedDetailFields[v] == 'product_id'){
                                dynamic_line.push('PCode')
                            } else if(this.checkedDetailFields[v] == 'stock_no'){
                                dynamic_line.push('Stock No.')
                            } else if(this.checkedDetailFields[v] == 'product_name'){
                                dynamic_line.push('Description')
                            } else {
                                let s = this.checkedDetailFields[v]
                                let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                                dynamic_line.push(format_detail)
                            } 
                        }
                        let headerData = []
                        for(let x=0; x < siteSpecific.length; x++){
                            this.birSalesReports = siteSpecific[x].report_details
    
                            let grouper = ''
                            let reportData = []
                            if(this.birSalesReports.length > 0){
                                let subtotal = {}
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
    
                                    let header_detail = []
                                    let line_detail = []
    
                                    if(grouper == ''){
                                        for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }
    
                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                }
                                            } else if (field_value == 'origin_document_id'){
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push('Active')
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push(status_val)
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } 
                                        }
                                        reportData.push(header_detail)
                                    } else {
                                        
                                        if(grouper != reportLine.document_id){
                                            //if new document display prev dostartcument details 
    
                                            let sub_detail = []
                                            for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                                let field_value = this.checkedDetailFields[vd]
                                                if(field_value == 'product_name'){
                                                    sub_detail.push("Sub Total")
                                                } else {
                                                    if(subtotal[field_value] == undefined){
                                                        sub_detail.push('')
                                                    } else {
                                                        grandTotal += parseFloat(subtotal[field_value])
                                                        sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                    }
                                                }   
                                            }
    
                                            reportData.push(Object.assign({}, sub_detail))
    
                                            subtotal = {}
    
                                            for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                                let field_value = this.checkedHeaderFields[vd]
                                                
                                                if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                    field_value = `document_${field_value}`
                                                }
    
                                                if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                    if(reportLine[field_value] == null){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                    }
                                                } else if (field_value == 'origin_document_id'){
                                                    if(reportLine[field_value] == -1){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push(reportLine[field_value])
                                                    }
                                                } else if (field_value == 'document_status'){
                                                    if(reportLine[field_value] == 'A'){
                                                        header_detail.push('Active')
                                                    } else {
                                                        let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                        header_detail.push(status_val)
                                                    }
                                                } else {
                                                    if(reportLine[field_value] == null){
                                                        header_detail.push('')
                                                    } else {
                                                        header_detail.push(reportLine[field_value])
                                                    }
                                                } 
                                            }
                                            reportData.push(header_detail)
                                        }
                                    }
                                    
                                    grouper = reportLine.document_id
    
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
    
                                        if(reportLine[field_value] == null){
                                            line_detail.push('')
                                        } else {
                                            // console.log(field_value, reportLine[field_value], typeof(reportLine[field_value]))
                                            let align = 'left'
                                            let convert_me = false
                                            if(no_subtotal.includes(field_value)){
                                                //dont total
                                            } else {
                                                if (typeof(reportLine[field_value]) == "string"){
                                                    // console.log(parseFloat(reportLine[field_value]))
                                                    // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                    if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                        // console.log(subtotal[field_value])
                                                        if(subtotal[field_value] == undefined){
                                                            subtotal[field_value] = Number(reportLine[field_value])
                                                        } else {
                                                            subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                        }
    
                                                        align = 'right'
                                                        convert_me = true
                                                    }
                                                    // console.log(subtotal)
                                                }
                                            }
    
                                            if(convert_me == true){
                                                line_detail.push(this.convertToCurrency(Number(reportLine[field_value])))
                                            } else {
                                                line_detail.push(reportLine[field_value])
                                            }
                                        }
                                    }
                                    if (x==0 && i==0){
                                        reportData.push(dynamic_line)
                                    }
                                   
                                    reportData.push(line_detail)
    
                                    if(i == this.birSalesReports.length-1){
    
                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                sub_detail.push("Sub Total")
                                            } else {
                                                if(subtotal[field_value] == undefined){
                                                    sub_detail.push('')
                                                } else {
                                                    grandTotal += parseFloat(subtotal[field_value])
                                                    sub_detail.push(this.convertToCurrency(subtotal[field_value]))
                                                }
                                            }   
                                        }
    
                                        reportData.push(Object.assign({}, sub_detail))
    
                                        subtotal = {}
                                    }
                                }
                                
                            }
    
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
                            var GrandTotal = [" "," "," ","Grand Total:",grandTotal]
                            reportData.push(GrandTotal)
                            if(x === siteSpecific.length - 1) {
                                reportData.push([`${trans_val} Journal`, "Generate By: " + printed_by,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A')])
                            }
                            let keys = dynamic_header;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                          [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                            // this.JsonData = site_specific;
                        }
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        this.openNotificationWithIcon('error', 'No Data.');
                    }
                    this.spinning= false;
                },
                generateFlatFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let grandTotalQuantity = 0;
                let grandTotalSRP = 0;
                let processedDocs = new Set(); 

                let brands = "";
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from":  this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to":  this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "type": this.$attrs.friendlyCode,
                    "status": this.inputStatus,
                    "order_status": this.inputOrderStatus,
                    "brands": brands,
                    "order_source": this.inputOrderSource
                }

                // var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null);
                parameters.current_profile = this.currentProfile
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'operation_report_ado?',parameters, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks"]

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
    
                    let header_prefix = this.$attrs.friendlyCode
                    let origin_prefix = 'Origin Doc'
                    let party = 'Party'

                    if (this.$attrs.friendlyCode == 'RELADJ'){
                        header_prefix = 'ADO'
                    }
                    let field_count = this.checkedHeaderFields.length
                    let header_count = this.checkedHeaderFields.length
                    let line_count = this.checkedDetailFields.length
                    if(field_count < line_count){
                        field_count = line_count
                    }
                    let site_specific = []
                    let dynamic_header = []
                    let dynamic_h = []
                    for(let v=0; v < this.checkedHeaderFields.length; v++){
                        if(this.checkedHeaderFields[v] == 'order_source'){
                            dynamic_h.push('Order Source')
                        } 
                        else if(this.checkedHeaderFields[v] == 'document_no'){
                            dynamic_h.push(`${header_prefix} #`)
                        } else if(this.checkedHeaderFields[v] == 'site_name'){
                            dynamic_h.push('Target Branch')
                        } else if(this.checkedHeaderFields[v] == 'document_date'){
                            dynamic_h.push(`${header_prefix} Date`)
                        } else if(this.checkedHeaderFields[v] == 'posted_at'){
                            dynamic_h.push(`${header_prefix} Post Date`)
                        } else if(this.checkedHeaderFields[v] == 'cas_no'){
                            dynamic_h.push('Cas Series #')
                        } else {
                            let s = this.checkedHeaderFields[v]
                            let format_header = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_h.push(format_header)
                        } 
                    }

                    let dynamic_l = []
                    
                    for(let v=0; v < this.checkedDetailFields.length; v++){
                        if(this.checkedDetailFields[v] == 'product_name'){
                            dynamic_l.push('Description')
                        }else if(this.checkedDetailFields[v] == 'brand_name'){
                            dynamic_l.push('Brand')
                        }else if(this.checkedDetailFields[v] == 'subtotal'){
                            dynamic_l.push('Total SRP')
                        }else if(this.checkedDetailFields[v] == 'company_name'){
                            dynamic_l.push('Company')
                        }else {
                            let s = this.checkedDetailFields[v]
                            let format_detail = s.charAt(0).toUpperCase() + s.slice(1)
                            dynamic_l.push(format_detail)
                        } 
                    }

                    dynamic_header = [...dynamic_h,...dynamic_l]
                    let headerData = []
                    let reportData = []
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        if(this.birSalesReports.length > 0){
                            let subtotal = {}
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let header_detail = []
                                let line_detail = []

                                if(grouper == ''){
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                        let field_value = this.checkedHeaderFields[vd]
                                        
                                        if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                            field_value = `document_${field_value}`
                                        }

                                        if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                           if(reportLine[field_value] == null){
                                               header_detail.push('')
                                           } else {
                                               header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                           }
                                        } else if (field_value == 'origin_document_no'){
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                        } else if (field_value == 'document_status'){
                                            if(reportLine[field_value] == 'A'){
                                                header_detail.push('Active')
                                            } else {
                                                let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                header_detail.push(status_val)
                                            }
                                        } else {
                                            if(reportLine[field_value] == null){
                                                header_detail.push('')
                                            } else {
                                                header_detail.push(reportLine[field_value])
                                            }
                                        } 
                                    }
                                } else {
                                    
                                    if(grouper != reportLine.document_id){
                                        //if new document display prev dostartcument details 

                                        let sub_detail = []
                                        for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                            let field_value = this.checkedDetailFields[vd]
                                            if(field_value == 'product_name'){
                                                // sub_detail.push("Sub Total")
                                            } else {
                                                if (!processedDocs.has(grouper)) { // Only add if not processed
                                                    if (field_value === 'quantity') {
                                                        grandTotalQuantity += parseFloat(subtotal['quantity']);
                                                    }
                                                    if (field_value === 'subtotal') {
                                                        grandTotalSRP += parseFloat(subtotal['subtotal']);
                                                    }
                                                }
                                            }   
                                        }

                                        subtotal = {}
                                        // reportData.push(header_detail)
                                    }
                                    for(let vd=0; vd < this.checkedHeaderFields.length; vd++){
                                            let field_value = this.checkedHeaderFields[vd]
                                            
                                            if (field_value == 'id' || field_value == 'discount_text' || field_value == 'tax_rate' || field_value == 'tax_amount' || field_value == 'status' || field_value == 'created_at' || field_value == 'updated_at' || field_value == 'account_id'){
                                                field_value = `document_${field_value}`
                                            }

                                            if(field_value == 'document_date' || field_value == 'posted_at' || field_value == 'origin_document_date'){
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(moment(reportLine[field_value]).format('MM/DD/YYYY'))
                                                }
                                            } else if (field_value == 'origin_document_no'){
                                                if(reportLine[field_value] == -1){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } else if (field_value == 'document_status'){
                                                if(reportLine[field_value] == 'A'){
                                                    header_detail.push('Active')
                                                } else {
                                                    let status_val = this.statusOptions.find(x => x.key === reportLine[field_value]).value
                                                    header_detail.push(status_val)
                                                }
                                            } else {
                                                if(reportLine[field_value] == null){
                                                    header_detail.push('')
                                                } else {
                                                    header_detail.push(reportLine[field_value])
                                                }
                                            } 
                                        }
                                }
                                
                                grouper = reportLine.document_id

                                for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                    let field_value = this.checkedDetailFields[vd]
                                    if(reportLine[field_value] == null){
                                        line_detail.push('')
                                    } else {
                                        let align = 'left'
                                        let convert_me = false
                                        if(no_subtotal.includes(field_value)){
                                            //dont total
                                        } else {
                                            if (typeof(reportLine[field_value]) == "string"){
                                                // console.log(parseFloat(reportLine[field_value]))
                                                // console.log(_.isNaN(parseFloat(reportLine[field_value])))
                                                if(_.isNaN(parseFloat(reportLine[field_value])) == false){
                                                    // console.log(subtotal[field_value])
                                                    if(subtotal[field_value] == undefined){
                                                        subtotal[field_value] = Number(reportLine[field_value])
                                                    } else {
                                                        subtotal[field_value] = subtotal[field_value] + Number(reportLine[field_value])
                                                    }

                                                    align = 'right'
                                                    convert_me = true
                                                }
                                            }
                                        }

                                        if(convert_me == true){
                                            line_detail.push(this.convertToCurrency(Number(reportLine[field_value])))
                                        } else {
                                            line_detail.push(reportLine[field_value])
                                        }
                                    }
                                }
                                // reportData.push(dynamic_line)
                                const combinedFields = [...header_detail, ...line_detail];
                                if (combinedFields.length<dynamic_header.length){
                                    var space = []
                                    for(let i=0; i < dynamic_h.length; i++){
                                        space.push('')
                                    }
                                    combinedFields = [...space,...combinedFields]
                                }
                                // console.log(combinedFields)
                                reportData.push(combinedFields)

                                if(i == this.birSalesReports.length-1){

                                    let sub_detail = []
                                    for(let vd=0; vd < this.checkedDetailFields.length; vd++){
                                        let field_value = this.checkedDetailFields[vd]
                                        if(field_value == 'product_name'){
                                            sub_detail.push("Sub Total")
                                        } else {
                                            if(subtotal[field_value] == undefined){
                                                sub_detail.push('')
                                            } else {
                                                if (!processedDocs.has(grouper)) { // Only add if not processed
                                                    if (field_value === 'quantity') {
                                                        grandTotalQuantity += parseFloat(subtotal['quantity']);
                                                    }
                                                    if (field_value === 'subtotal') {
                                                        grandTotalSRP += parseFloat(subtotal['subtotal']);
                                                    }
                                                }
                                            }
                                        }   
                                    }

                                    subtotal = {}
                                }
                            }
                            
                        }

                        
                        
                    }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    } 
                    var space = []
                    for(let i=0; i < dynamic_h.length; i++){
                        space.push('')
                    }
                    var GrandTotal = [" "," "," ","Grand Total:",this.convertToCurrency(grandTotalQuantity),this.convertToCurrency(grandTotalSRP)]
                    GrandTotal = [...space,...GrandTotal]
                    reportData.push(GrandTotal)
                    reportData.push([`${trans_val} Journal`, "Generate By: " + printed_by,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A')])
                    let keys = dynamic_header;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }
                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)
                    this.JsonData = site_specific;
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
                clearJsonData(){
                  // console.log("working",this.JsonData)
                  this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>